export default {
  width: 47,
  height: 47,
  stroke: true,
  svg: '<path d="M16.82 16.1653L23 3L29.18 16.1653L43 18.2768L33 28.5273L35.3599 43L23 36.1693L10.6401 43L13 28.5273L3 18.2768L16.82 16.1653Z" fill="white" stroke-width="2"/>'
}
